angular.module('logbook').service('reportBuilderService', ['$http', function($http) {
    // #region QueryBuilder filters

    this.noteTimeframe = {
        valueGetter: function(rule) {
            var values = [];

            var $ruleValueContainer = rule ?
                rule.$el.find('.rule-value-container .' + rule.operator.type + ' input:checked') :
                // used in report-builder-starter directive
                $('#timeframe-container input:checked');

            $ruleValueContainer.closest('div').find(':input').each(function() {
                values.push(this.value);
            });
            
            return values;
        },
        valueSetter: function(rule, value) {
            rule.$el.find('.rule-value-container .' + rule.operator.type + ' input[value="' + value[0] + '"]').prop('checked', 'true');

            if (value.length > 1) {
                var inputs = rule.$el
                    .find('.rule-value-container .' + rule.operator.type + ' input:checked')
                    .closest('div')
                    .find(':input, select');

                for (var i = 1; i < inputs.length; i++) {
                    $(inputs[i]).val(value[i]);
                }
            }
        }
    }
    
    // #endregion
    
    this.validateDateTime = function(value) {
        switch (value[0]) {
            case 'Number of Days Ago':
                value[1] = parseInt(value[1], 10);
                break;

            case 'Between Days Ago':
                value[1] = parseInt(value[1], 10);
                value[2] = parseInt(value[2], 10);

                if (value[1] < value[2]) {
                    var x = value[1];
                    value[1] = value[2];
                    value[2] = x;
                }
                break;

            case 'Between Dates':
            case 'Between Dates/Times':
                if (Date.parse(value[1]) > Date.parse(value[2])) {
                    var x = value[1];
                    value[1] = value[2];
                    value[2] = x;
                }
                break;
        }

        return true;
    };

    this.getOperatorForTimeframe = function(timeframe) {
        return ['Today', 'Yesterday', 'Previous Weekday', 'Number of Days Ago', 'Specific Date'].includes(timeframe) ?
            'specific-date' :
            'date-range';
    };
}]);